import { useMutation } from "@tanstack/react-query";
import { actions, isInputError } from "astro:actions";
import { navigate } from "astro:transitions/client";
import { $path } from "astro-typesafe-routes/path";
import { useState } from "react";

import { useCreateQueryClient } from "~/hooks/query";

import { DialogBody } from "../DialogBody";
import { DialogHeader } from "../DialogHeader";
import { TextField } from "../TextField";

export const ClassCodeForm: React.FC = () => {
  const [code, setCode] = useState("");

  const queryClient = useCreateQueryClient();
  const { mutate, error, isPending, isSuccess } = useMutation(
    {
      mutationFn: actions.assignment.validateCode.orThrow,
      onSuccess: (slug) => {
        navigate(
          $path({
            to: "/assignments/[slug]",
            params: { slug },
          }),
        );
      },
    },
    queryClient,
  );

  return (
    <form
      autoComplete="off"
      className="contents"
      onSubmit={(event) => {
        event.preventDefault();
        mutate({ code });
      }}
    >
      <DialogHeader>Class code</DialogHeader>
      <DialogBody className="space-y-4">
        <TextField
          required
          error={isInputError(error) ? error.fields.code?.[0] : undefined}
          placeholder="Enter your class code here"
          className="input-lg w-full"
          value={code}
          onChange={(event) => {
            setCode(event.target.value.trim().toUpperCase());
          }}
        />
        <button
          disabled={isPending || isSuccess}
          type="submit"
          className="btn btn-secondary btn-lg btn-block"
        >
          Join game
        </button>
      </DialogBody>
    </form>
  );
};
